/// HOOKS ///
import { useAppDispatch } from "api/hooks/apiHook";
import { useAppSelector } from "api/hooks/apiHook";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useState } from "react";
/// ACTIONS ///
import { createFabricationJob } from "api/actions/end_customer";
import { updateFabricationJob } from "api/actions/end_customer";
import { setBreadcrumbs } from "api/actions/ui/set";
import { getQuote } from "api/actions/quotes/quote";
import { updateLocalQuote } from "api/actions/quotes/quote";
/// TYPES ///
import { IFabricationJob } from "api/types/customer";
import { IFabricationJobError } from "api/types/customer";
/// COMPONENTS ///
import UpdateJob from "components/quote/update_job";
/// BREADCRUMBS ///
import { quote_list } from "values/breadcrumbs/quote";
import { quote_preview } from "values/breadcrumbs/quote";
import { quote_update_job } from "values/breadcrumbs/quote";
/// VALIDATE ///
import { validateEmail } from "functions/value";

interface Props {
  base_url: string
}

export default function UpdateStoreQuoteJob({ base_url }: Props) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { id, customer_id } = useParams();
  const { quote } = useAppSelector((state) => state.quote);
  const [job, setJob] = useState<IFabricationJob>({});
  const [errors, setErrors] = useState<IFabricationJobError>({});

  useEffect(() => {
    setJob(quote?.job_data ?? {});
  }, [quote?.job_data]);

  useEffect(() => {
    if (!quote?.id || quote.id.toString() !== id) {
      dispatch(getQuote(id));
    }
  }, [dispatch, id]);

  useEffect(() => {
    dispatch(setBreadcrumbs([
      { ...quote_list, url: quote_preview.url.replace("base_url", base_url) },
      { ...quote_preview, url: quote_preview.url.replace("base_url", base_url).replace("id", id) },
      { ...quote_update_job, url: quote_update_job.url.replace("base_url", base_url).replace("id", id) }
    ]));
  }, [dispatch, id, base_url]);

  const update = () => {
    const errors: IFabricationJobError = {};

    if (!job?.lat || job?.lat === 0 || !job?.lng || job?.lng === 0) {
      errors.geo_error = "Could not find coordinates for this address. Please retype the address and select it from the dropdown options.";
      errors.geo_has_error = true;
    }

    if (!validateEmail(job?.email)) {
      errors.email_error = "Must enter a valid email";
      errors.email_has_error = true;
    }

    setErrors(errors);
    if (errors?.email_has_error || errors?.geo_has_error) {
      return;
    }

    if (quote?.job) {
      dispatch(updateFabricationJob(job, quote.job));
    }
    else {
      dispatch(createFabricationJob({ ...job, end_customer: Number(customer_id) }, quote.id));
    }

    dispatch(updateLocalQuote({ job_data: job }));
    navigate(-1);
  }

  return (
    <UpdateJob
      title="Edit Job"
      email={job?.email ?? ""}
      setEmail={email => { setJob({ ...job, email }); setErrors({ ...errors, email_error: "", email_has_error: false }) }}
      entry_notes={job?.entry_notes ?? ""}
      setEntryNotes={entry_notes => setJob({ ...job, entry_notes })}
      geo_address={job?.geo_address ?? ""}
      setGeoAddress={(geo_address, lat, lng) => setJob({ ...job, geo_address, lat, lng })}
      phone_number={job?.phone_number ?? ""}
      setPhoneNumber={phone_number => setJob({ ...job, phone_number })}
      errors={errors}
      setErrors={setErrors}
      update={update}
    />
  )
}
